import React from 'react';
import { Grid, CircularProgress, IconButton, Typography } from '@material-ui/core';

import {
  DashboardContainer,
  DashboardHeader,
  DashboardTitle,
  FiltersContainer,
  ChartContainer,
  HalfChartContainer,
  TableContainer,
  EmptyState,
  SectionTitle,
} from './dashboard.styles';
import { useAnalytics } from '@lib/common/hooks/use-analysis';
import FiltersBar from '../components/filter-bar';
import KPICards from '../components/KPI-cards';
import { AppBarTitle } from '@components/app-bar-title';
import { RiSearchFill } from 'react-icons/ri';
import TrendChart from '../components/trend-chart';
import FieldBarChart from '../components/field-barchart';
import ActionPieChart from '../components/action-piechart';
import HeatMap from '../components/heatmap';
import SummaryTable from '../components/summary-table';
import DistributionChart from '../components/distribution-chart';

const AnalyticsDashboard = () => {
  const {
    loading,
    error,

    records,

    filters,
    setFilters,

    kpiData,
    trendData,
    fieldChartData,
    actionChartData,
    heatMapData,
    summaryData,
    distributionData,
  } = useAnalytics();

  if (loading) {
    return (
      <DashboardContainer display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </DashboardContainer>
    );
  }

  if (error) {
    return (
      <DashboardContainer>
        <EmptyState>{error}</EmptyState>
      </DashboardContainer>
    );
  }

  return (
    <DashboardContainer>
      <AppBarTitle>
        <IconButton color="inherit">
          <RiSearchFill />
        </IconButton>{' '}
        Database logs Secondary - Dashboard
      </AppBarTitle>
      <DashboardHeader>
        <div>
          <DashboardTitle>Analytics Dashboard</DashboardTitle>

          <Typography variant="body2" color="textSecondary">
            Database Activity Overview
          </Typography>
        </div>
      </DashboardHeader>

      <FiltersContainer>
        <FiltersBar filters={filters} setFilters={setFilters} records={records} />
      </FiltersContainer>

<KPICards
  kpiData={kpiData}
  period={filters.period}
  action={filters.action}
  onPeriodChange={period =>
    setFilters(prev => ({
      ...prev,
      period,
    }))
  }
/>
      <Grid container spacing={3} style={{ marginTop: 6 }}>
        <Grid item xs={12} md={7}>
          <TrendChart data={trendData} filters={filters} />
        </Grid>

        <Grid item xs={12} md={5}>
          <ActionPieChart data={actionChartData}     period={filters.period}/>
        </Grid>
      </Grid>

      <ChartContainer>
              {/* <SectionTitle>Daily Trend</SectionTitle> */}
        <FieldBarChart data={fieldChartData}   period={filters.period}
 />
            
      </ChartContainer>

      <ChartContainer style={{ marginTop: 24 }}>
        <SectionTitle>Activity Heatmap</SectionTitle>

        <HeatMap data={heatMapData} period={filters.period}/>
      </ChartContainer>

      <ChartContainer style={{ marginTop: 24 }}>
        <SectionTitle>Distribution</SectionTitle>

        <DistributionChart data={distributionData} />
      </ChartContainer>

      <TableContainer>
        <SectionTitle>Summary</SectionTitle>

        <SummaryTable data={summaryData} />
      </TableContainer>
    </DashboardContainer>
  );
};

export default AnalyticsDashboard;
